<template>
  <div>
    <link rel="stylesheet" href="/static/js/editor.md/css/editormd.min.css"/>
    <link rel="stylesheet" href="/static/js/highlight/styles/a11y-light.min.css"/>
    <!-- <pre>
      <code id="answer" class="python">
        <div id="test-editormd" style="width: 100%;margin: 10px" >
          <textarea style="display: none" name="test-editormd-markdown-doc">{{taskInfo.assessmentContent}}</textarea>
        </div>
      </code>
    </pre> -->
    <div :id="editorId" :style="'width: auto;'+styleInfo" >
      <textarea style="display: none" name="test-editormd-markdown-doc">{{modelValue}}</textarea>
    </div>
  </div>
</template>

<script>
import scriptjs from 'scriptjs';
function uuid () {
  let s = []
  let hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  return s.join('')
}
export default {
  name: 'PreviewIndex',
  model: {
    prop: 'modelValue',
  },
  props: {
    styleInfo: {
      type: String,
      default: "border:1px solid #e3e3e3"
    },
    editorId: {
      type: String,
      default: uuid()
    },
    modelValue: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      editor: {}
    }
  },
  mounted() {
    // 设置延迟初始化markdown编辑器, 因为只会初始化一次，需要等待数据加载完成之后再初始化
    this.initEditor();
  },
  methods: {
    initEditor() {
      (async() => {
        await this.fetchScript('/static/js/editor.md/jquery-1.11.3.min.js')
        await this.fetchScript('/static/js/editor.md/editormd.min.js')
        await this.fetchScript('/static/js/editor.md/lib/marked.min.js')
        await this.fetchScript('/static/js/editor.md/lib/prettify.min.js')
        await this.fetchScript('/static/js/editor.md/lib/raphael.min.js')
        await this.fetchScript('/static/js/editor.md/lib/underscore.min.js')
        await this.fetchScript('/static/js/editor.md/lib/sequence-diagram.min.js')
        await this.fetchScript('/static/js/editor.md/lib/flowchart.min.js')
        await this.fetchScript('/static/js/editor.md/lib/jquery.flowchart.min.js')
        await this.fetchScript('/static/js/highlight/highlight.min.js')
        this.$nextTick(() => {
          var testEditor;
          testEditor = editormd.markdownToHTML(this.editorId, {
              htmlDecode :"style, script, iframe",
              emoji           : true,
              taskList        : true,
              tex             : true,  // 默认不解析
              flowChart       : true,  // 默认不解析
              sequenceDiagram : true,  // 默认不解析
          });
          
            // let htm = $("#"+this.editorId).html().replace(/\[—-\]/g,"___①___");
            let arrayHtml = $("#"+this.editorId).html().split("\[—-\]");
            let htm = "";
            for(let i = 0;i < arrayHtml.length;i++){
              htm += arrayHtml[i] + (i < arrayHtml.length - 1?"<span style='color:#2789E2;'>_____"+this.$chineseNum(i,1)+"_____</span>":"");
            }
            $("#"+this.editorId).html(htm);
        });
        
        // setTimeout(()=>{
        //   hljs.highlightAll();//初始化代码格式 代码高亮
        //   //添加序号（根据换行符对数据进行处理）
        //   // var arr = $("#answer").html().split("\n");
        //   // var text = "<ol>";
        //   // $.each(arr,function(ii,item){
        //   //     if(item.trim()!=""){
        //   // 		text += "<li>"+item +"</li>";
        //   //     }
        //   // });
        //   // text += "</ol>";
        //   // $("#answer").html(text);
        // },5000)
      })()
    },
    fetchScript(url) {
      return new Promise((resolve) => {
        scriptjs(url, () => {
          resolve()
        })
      })
    }
  }
}
</script>

<style scoped>
/* 上传图片弹窗样式有点问题，可能是冲突了 */
#editor::v-deep(.editormd-dialog-header) {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/editorMd/previewIndex.vue